import {
  ch05Viz1, ch05Viz10, ch05Viz2, ch05Viz3, ch05Viz4, ch05Viz5, ch05Viz6, ch05Viz7, ch05Viz8, ch05Viz9,
} from './subCh05Img';

export default [
  ch05Viz1,
  ch05Viz2,
  ch05Viz3,
  ch05Viz4,
  ch05Viz5,
  ch05Viz6,
  ch05Viz7,
  ch05Viz8,
  ch05Viz9,
  ch05Viz10,

];
